interface FounderStoryProps {
  className?: string;
}

const FounderStory = ({ className = '' }: FounderStoryProps) => {
  const bullets = [
    'Need speed? A cash offer can close in 30 days or less.',
    'Have a low mortgage rate worth keeping? A loan assumption can preserve it.',
    'Sitting on hidden equity? Creative financing can unlock it.',
    "Best served by the open market? I’ll recommend a traditional MLS listing — even though it earns us less.",
  ];

  return (
    <section className={`bg-surface py-16 lg:py-24 ${className}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <div className="mb-12 h-px w-20 bg-accent"></div>
            <div className="mb-6 font-heading text-xl italic text-primary">
              About Christopher, Founder of Silk Solutions
            </div>
            <h2 className="font-heading text-[46px] font-normal leading-[1] text-foreground md:text-[62px]">
              Why I built this <span className="italic text-plum">differently</span>
            </h2>
          </div>

          <div className="border border-border bg-card/70 p-8 shadow-card md:p-10">
            <div className="space-y-5 text-[16px] leading-relaxed text-muted-foreground">
              <p>
                Silk Solutions is a real estate solutions company that helps homeowners whose
                situations don&apos;t fit the traditional sales process. Instead of one option, we
                offer several — cash offers, loan assumptions, creative financing, investor pairing,
                tenant-occupied sales, and traditional MLS listings — and match the right one to each
                seller&apos;s circumstances.
              </p>

              <p>
                I&apos;m Christopher, and I founded Silk Solutions after years in real estate kept
                showing me the same problem.
              </p>

              <p>
                The traditional process is built for one kind of seller: a move-in-ready home, no
                financial pressure, and time to wait. Anyone outside that profile gets handed the
                same playbook anyway — whether it fits or not.
              </p>

              <p>
                A family 60 days from foreclosure is told to list and hope. A landlord with tenants
                in place is told to evict first, then sell. An heir managing an inherited property
                from another state is told to fly in, repair it, and wait for an offer.
              </p>

              <p>Different properties. Different situations. The same answer for everyone.</p>

              <p>So I built something different.</p>

              <p>
                <strong className="font-bold text-foreground">
                  Silk Solutions exists for the homeowner whose situation doesn&apos;t fit the
                  standard process.
                </strong>{' '}
                We start by understanding your specifics — timeline, mortgage balance, property
                condition, tenant status — then find the path that actually works:
              </p>

              <ul className="space-y-3">
                {bullets.map((bullet) => (
                  <li key={bullet} className="flex gap-3">
                    <span className="mt-1 text-accent">•</span>
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>

              <p className="font-heading text-xl italic text-foreground">
                My job isn&apos;t to push one solution. It&apos;s to find the right one.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;
